/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect } from "react"
import PropTypes from "prop-types"

import Seo from "@components/seo"

import * as styles from "./index.module.scss"
import AppContext, { useAppContext } from "@src/context/appContext"
import { getCssTag } from "@src/utils/ui"
import logoImg from "@images/loading.png"
import classnames from "gpages/utils/classnames"
import { useBrowserLayout } from "gpages/hooks/layout"
import { throttle } from "lodash"
import Container from "@src/components/container"

import gcLogoSvgImg from "@images/gc-logo.svg"
import { wxConfig, wxShare } from "@src/utils/wechat"

const layoutModeMapper = {
  xs: 0, // <= 500
  s: 1, // <= 1000
  m: 2, // > 1000
  l: 3, // >= 1920
}

const Layout = ({ children, location }) => {
  const [layoutTag, setLayoutTag] = React.useState()
  const [initialized, setInitialized] = React.useState(false)

  const { isMobileLayout, isMobile, isWXBrowser, isNative } = useBrowserLayout({
    designWidth: 820,
    designHeight: 1180,
  })

  useEffect(() => {
    wxConfig()
    wxShare()
  }, [])

  useEffect(() => {
    const resizeEvent = () => {
      const layoutTag = getCssTag("html")
      setLayoutTag(layoutTag)

      const cssList = document.documentElement.classList
      for (const mode of Object.keys(layoutModeMapper)) {
        cssList.remove(`app-layout-${mode}`)
      }
      cssList.add(`app-layout-${layoutTag}`)

      setTimeout(() => {
        setInitialized(true)
      }, 1000)
    }
    const throttled = throttle(resizeEvent, 500)

    resizeEvent()
    window.addEventListener("resize", throttled)
    return () => {
      window.removeEventListener("resize", throttled)
    }
  }, [])

  return (
    <AppContext.Provider
      value={{
        isMobile,
        isNative,
        isWXBrowser,
        isMobileLayout,
        layoutTag,
        layoutMode: layoutModeMapper[layoutTag],
      }}
    >
      <Seo />

      <div
        className={classnames(styles.loading, {
          [styles.loadingVisible]: !initialized,
        })}
      >
        <img src={logoImg} alt="logo" />
        {/* <h3>LOADING...</h3> */}
      </div>

      <div className={styles.container}>
        <main>{children}</main>
      </div>
      <footer className={styles.footer}>
        <Container>
          <img src={gcLogoSvgImg} alt="logo" />
          <p>
            Copyright © 2009 - 2024 GAMECORES.<span>All Rights Reserved</span>
          </p>
        </Container>
      </footer>
    </AppContext.Provider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
